import React from 'react';
import './Layout.scss';

interface LayoutProps {
    children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="layout">
            <main className="layout__content">
                {children}
            </main>
        </div>
    );
};